/**
 * components/tableElements/TableFooter.jsx
 */

import {
    useCrudListState,
    useCrudListDispatch,
    ACTIONS,
} from "../../context/CrudContext";

export default function TableFooter() {
    const dispatch = useCrudListDispatch();
    const state = useCrudListState();
    const { page, perPage, total } = state;

    const totalPages = Math.max(1, Math.ceil(total / perPage));
    if (totalPages <= 1 && total <= perPage) return null;

    // Compact page window
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
        if (i === 1 || i === totalPages || (i >= page - 1 && i <= page + 1)) {
            pages.push(i);
        } else if (pages[pages.length - 1] !== "…") {
            pages.push("…");
        }
    }

    return (
        <div className="px-4 sm:px-6 py-5 bg-gray-50 border-t border-gray-200 rounded-b-lg">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="text-sm text-gray-500">
                    Showing {Math.min((page - 1) * perPage + 1, total)}–
                    {Math.min(page * perPage, total)} of {total} forms
                </div>

                <div className="flex items-center space-x-1">
                    <button
                        onClick={() =>
                            dispatch({
                                type: ACTIONS.SET_PAGE,
                                payload: page - 1,
                            })
                        }
                        disabled={page === 1}
                        className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Previous
                    </button>

                    {pages.map((p, i) =>
                        p === "…" ? (
                            <span
                                key={`e${i}`}
                                className="px-2 text-sm text-gray-400"
                            >
                                …
                            </span>
                        ) : (
                            <button
                                key={p}
                                onClick={() =>
                                    dispatch({
                                        type: ACTIONS.SET_PAGE,
                                        payload: p,
                                    })
                                }
                                className={`px-3 py-1 text-sm rounded ${
                                    page === p
                                        ? "bg-accent text-white"
                                        : "text-gray-600 hover:text-gray-800"
                                }`}
                            >
                                {p}
                            </button>
                        ),
                    )}

                    <button
                        onClick={() =>
                            dispatch({
                                type: ACTIONS.SET_PAGE,
                                payload: page + 1,
                            })
                        }
                        disabled={page === totalPages}
                        className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Next
                    </button>
                </div>
            </div>
        </div>
    );
}
